import React, { Component } from 'react';
import { Layout } from 'antd';
import './index.scss';
const { Content } = Layout;

class BlankLayout extends Component {
  render() {
    return (
      <div className="blank-layout-container h-100">
        <Layout className="blank-layout-content-wrapper h-100">
          <Content>
            {React.cloneElement(this.props.children)}
          </Content>
        </Layout>
      </div>
    )
  }
}

export default BlankLayout;
